import { z } from "zod";
import { parse } from "date-fns";
import { parameterBaseSchema } from "./parameterBase.schema";
import { ParameterTypeEnum } from "./ParameterType.enum";

/**
 * Parse to a date object unless it was a date object all along!
 */
const dateRangeDate = z
    .union([z.string(), z.date()])
    .nullish()
    .transform((s) => s ?? undefined)
    .transform((s) => {
        if (!s) {
            return undefined;
        }

        if (s instanceof Date) {
            return s;
        }

        return parse(s, "yyyy-MM-dd", new Date());
    });
/**
 * Schema for date range parameter
 */
export const dateRangeSchema = parameterBaseSchema.merge(
    z.object({
        type: z.literal(ParameterTypeEnum.DATE_RANGE),
        startMinDate: dateRangeDate,
        startMaxDate: dateRangeDate,
        endMinDate: dateRangeDate,
        endMaxDate: dateRangeDate,
    })
);
